// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/object-get-own-property-symbols.js
// module id = 104
// module chunks = 0 1